import { useEffect, useContext } from 'react';
import { ListerContext } from '../../listerContext';
import usePrevious from '../../../../hooks/usePrevious';

function usePageResetWatcher(effectFn: () => void): void {
  const [
    {
      pagination: { sort },
      breadcrumbs
    }
  ] = useContext(ListerContext);

  const prevSort = usePrevious(sort);
  useEffect(() => {
    if (prevSort && sort) {
      effectFn();
    }
  }, [breadcrumbs.length, sort]);
}

export default usePageResetWatcher;
